import gql from 'graphql-tag';

export const CREATE_LEAD = gql`
    mutation addLead($data: leads_insert_input!) {
        insert_leads_one(object: $data) {
            id
        }
    }
`;